import axios from 'axios';
import {
  createAuditHistoryRequest,
  createAuditHistorySuccess,
  createAuditHistoryFailure,
  // fetchAuditHistoryRequest,
  // fetchAuditHistorySuccess,
  // fetchAuditHistoryFailure,
} from '../Reducer/productReducer';

export const createAuditHistory = (auditHistory) => async (dispatch) => {
  console.log("audit history",auditHistory)
  dispatch(createAuditHistoryRequest());
  try {
    const response = await axios.post('/api/audit_history',auditHistory, {
      withCredentials: true,
    });
    console.log("data form audit history",response.data)
    dispatch(createAuditHistorySuccess(response.data.auditRecords));
  } catch (err) {
    console.error('Create audit history error:', err);
    dispatch(createAuditHistoryFailure('Failed to create audit history.'));
  }
};


// Action to fetch the audit history list

